import { useCallback } from 'react';

import FilterBuilder from '../common/FilterBuilder';
import FilterChips from '../common/FilterChips';

/**
 * Which items a page layout draws from: its subject query, or one query block's
 * (KPR-953). The list's own pieces, as every other stored query uses them:
 * the active conditions as chips (a query the rows cannot split is ONE read-only
 * sentence, never rewritten), and the filter builder to add or change them. The
 * builder's own "Advanced" tab is the stored text, one click away.
 *
 * The stored text keeps its shape. Nothing is written until a person applies a
 * change in the builder or dismisses a chip, so a layout saved unedited carries
 * its query byte for byte.
 *
 * `fields` is the vocabulary (`buildFilterFields`): a layout is read in every
 * collection that uses its card, so it is every card the page can read, and the
 * card is asked here, in the query, as no toolbar picks it for a layout.
 */
export default function LayoutQueryFilter({
	query = '',
	onChange,
	fields = [],
	label,
	emptyText,
	collectionId = null,
	disabled = false,
}) {
	const apply = useCallback(text => onChange(`${text || ''}`.trim()), [onChange]);

	return (
		<div className="layout-query" role="group" aria-label={label}>
			{query ? (
				<FilterChips
					query={query}
					fields={fields}
					onChange={disabled ? undefined : apply}
					readOnly={disabled}
					className="layout-query__chips"
				/>
			) : null}
			{disabled ? null : (
				<FilterBuilder
					fields={fields}
					query={query || ''}
					onApply={apply}
					collectionId={collectionId}
					emptyText={emptyText}
				/>
			)}
		</div>
	);
}
